(() => {
  if (window.cicadaEffectsInitialized) return;
  window.cicadaEffectsInitialized = true;
  document.documentElement.classList.add('cicada-enhanced');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const cleanups = new Map();
  function setup(scope = document) {
    if (document.body.dataset.editorialMotion !== 'true' || reduced.matches) return;
    scope.querySelectorAll('.hero-motion').forEach(hero => {
      if (cleanups.has(hero)) return;
      let visible = false, frame = 0, x = 65, y = 35;
      const paint = () => {
        frame = 0;
        if (!visible) return;
        hero.style.setProperty('--light-x', `${x}%`);
        hero.style.setProperty('--light-y', `${y}%`);
        const top = hero.getBoundingClientRect().top;
        hero.style.setProperty('--hero-drift', `${Math.max(-24, Math.min(24, -top * .055))}px`);
      };
      const schedule = () => { if (visible && !frame) frame = requestAnimationFrame(paint); };
      const move = event => {
        if (!finePointer.matches) return;
        const box = hero.getBoundingClientRect();
        x = (event.clientX - box.left) / box.width * 100;
        y = (event.clientY - box.top) / box.height * 100;
        schedule();
      };
      const leave = () => { x = 65; y = 35; schedule(); };
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
      observer.observe(hero);
      hero.classList.add('interactive-light');
      hero.addEventListener('pointermove', move, { passive: true });
      hero.addEventListener('pointerleave', leave);
      window.addEventListener('scroll', schedule, { passive: true });
      cleanups.set(hero, () => {
        observer.disconnect(); cancelAnimationFrame(frame);
        hero.removeEventListener('pointermove', move); hero.removeEventListener('pointerleave', leave);
        window.removeEventListener('scroll', schedule);
        hero.classList.remove('interactive-light'); hero.style.removeProperty('--hero-drift');
        cleanups.delete(hero);
      });
    });
  }
  let dialog, returnFocus;
  function showPhoto(image, trigger) {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'photo-dialog';
      dialog.setAttribute('aria-label', 'Enlarged product photograph');
      const close = document.createElement('button');
      close.type = 'button'; close.className = 'photo-close'; close.textContent = 'Close ×';
      close.addEventListener('click', () => dialog.close());
      dialog.append(close, document.createElement('div'));
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('photo-open');
        if (returnFocus?.isConnected) returnFocus.focus();
      });
      document.body.append(dialog);
    }
    const photo = image.cloneNode();
    photo.removeAttribute('id'); photo.sizes = '100vw'; photo.loading = 'eager';
    dialog.lastElementChild.replaceChildren(photo);
    returnFocus = trigger;
    dialog.showModal(); document.documentElement.classList.add('photo-open');
    dialog.querySelector('button').focus();
  }
  document.addEventListener('click', event => {
    const thumbnail = event.target.closest('[data-photo-thumbnail]');
    if (thumbnail && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const source = document.getElementById(thumbnail.hash.slice(1))?.querySelector('img');
      const root = thumbnail.closest('[data-product-root]');
      if (!source || !root) return;
      event.preventDefault();
      root.querySelectorAll('.primary-media video').forEach(video => video.pause());
      const photo = source.cloneNode(); photo.loading = 'eager';
      root.querySelector('.primary-media').replaceChildren(photo);
      root.querySelectorAll('[data-photo-thumbnail]').forEach(link => link.removeAttribute('aria-current'));
      thumbnail.setAttribute('aria-current', 'true');
      root.querySelector('.gallery-status').textContent = thumbnail.getAttribute('aria-label');
    }
    const zoom = event.target.closest('[data-photo-zoom]');
    if (zoom) {
      const photo = zoom.closest('.product-gallery').querySelector('.primary-media img');
      if (photo) showPhoto(photo, zoom);
    }
  });
  reduced.addEventListener('change', () => { cleanups.forEach(cleanup => cleanup()); setup(); });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    cleanups.forEach((cleanup, hero) => { if (event.target.contains(hero)) cleanup(); });
  });
  setup();
})();
